<template>
  <div :id="molecule.id" class="molecule event-card">
    <figure class="relative w-full aspect-[5/3] mb-4 max-w-sm mx-auto">
      <img
        v-bind="imageAttrs"
        class="object-cover w-full h-full"
      />
      <AtomsCollectionButton
        class="absolute inline-block px-3 py-1 mb-4 bg-white rounded-full top-4 left-2 drop-shadow"
        :collection="molecule.collection"
      />
    </figure>
    <h4
      v-if="molecule.eventDate"
      class="event-date font-arial flex items-center text-sm text-black font-bold mb-4 before:content-[url('/img/heroicon-calendar.svg')] before:inline-block before:w-6 before:aspect-square before:mr-1"
    >
      {{ molecule.eventDate }}
    </h4>
    <h3
      class="mb-2 text-lg font-semibold leading-tight font-ubuntu text-bc-dark-blue"
    >
      {{ molecule.title }}
    </h3>
    <div
      v-if="molecule.description"
      v-html="molecule.description"
      class="mb-4 lg:mb-6 [&_*]:font-normal description text-gray-500 [&_a]:underline leading-snug"
    ></div>
    <MoleculesButtons :buttons="molecule" />
  </div>
</template>

<style>
.event-card {
  .description {
    @apply line-clamp-4 md:line-clamp-3;

    & > * {
      @apply hidden;
    }

    & > h1,
    & > h2,
    & > h3,
    & > h4,
    & > h5,
    & > h6 {
      @apply first:block;
    }

    & > p:first-of-type {
      @apply block line-clamp-4 md:line-clamp-3;
    }
  }

  .buttons {
    a.button {
      @apply py-2 uppercase text-base text-[15px];
    }
  }
}
</style>

<script setup>
const props = defineProps({ molecule: Object });

// Use responsive image composable for performance optimization
// Use 'medium' size which has 675x500 dimensions (1.35:1 aspect ratio, close to 5:3)
const imageAttrs = computed(() => useResponsiveImage(props.molecule.image, 'medium'));
</script>
